// API
// export const API_SERVER_URL = `http://${window.location.hostname}:8000/outdoor`;
export const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
export const PLAYER_URL_PREFIX = process.env.REACT_APP_PLAYER_URL_PREFIX;

export function showLoading(txt) {
  const loading = window.weui.loading(txt);
  return loading;
}

export function showAlert(txt) {
  window.weui.alert(txt);
}

export function showToast(txt) {
  window.weui.toast(txt);
}

// REM 适配
const REM_FIT_WIDTH = 2048;
function setPxPerRem() {
  const docEl = document.documentElement;
  docEl.style.fontSize = 100 * (docEl.clientWidth / REM_FIT_WIDTH) + "px";
}
export function enableRemAdaptor() {
  setPxPerRem();
  window.onresize = setPxPerRem;
}
export const px2rem = (value) => {
  const docEl = document.documentElement;
  return value / (docEl.clientWidth / REM_FIT_WIDTH);
};
export const rem2px = (value) => {
  const docEl = document.documentElement;
  return value * (docEl.clientWidth / REM_FIT_WIDTH);
};

// 发送 HTTP 请求
export async function apiRequest(path, method, params) {
  let url = `${API_SERVER_URL}${path}`;
  const fetchParams = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (method === "POST") fetchParams.body = JSON.stringify(params);
  if (method === "GET" && params) {
    const parmasArray = [];
    Object.keys(params).forEach((key) => {
      parmasArray.push(`${key}=${params[key]}`);
    });
    url = url + "?" + parmasArray.join("&");
  }
  const resp = await fetch(url, fetchParams);
  return resp.json();
}

export const formatPlayerNo = (player_no) => {
  if (player_no < 10) {
    return `0${player_no}`;
  } else {
    return `${player_no}`;
  }
};
